import axios from 'axios';
import showPreloader from './store/Actions';

const setCounterValue = (c, store) => {
  let counter = c;
  if (counter > 0) {
    counter -= 1;
  }
  if (counter <= 0) {
    store.dispatch(showPreloader(false));
  }
  return counter;
};

const interceptors = (store) => {
  let counter = 0;
  axios.interceptors.request.use(
    (config) => {
      const preloaderState =
        store.getState()?.sharedState?.showPreLoader?.showPreLoader;

      counter += 1;
      if (counter > 0 && !preloaderState) {
        store.dispatch(showPreloader(true));
      }
      return config;
    },
    (error) => {
      counter = setCounterValue(counter, store);
      Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (res) => {
      counter = setCounterValue(counter, store);
      return res;
    },
    (err) => {
      counter = setCounterValue(counter, store);
      return Promise.reject(err);
    }
  );
};

export default interceptors;
